import React from "react";
import { Card } from "@/components/ui/card";
import { Rows3 } from "lucide-react";

function fmtPower(p) {
  if (p === null || p === undefined) return "—";
  const s = p >= 0 ? "+" : "";
  return `${s}${p.toFixed(2)} D`;
}

function EyeComparison({ side, data, primary }) {
  if (!data?.comparison) return null;
  const rows = Object.entries(data.comparison);
  const values = rows.map(([, v]) => v);
  const median = [...values].sort((a, b) => a - b)[Math.floor(values.length / 2)];
  const isPrimary = (name) => primary && name.toLowerCase().startsWith(primary.toLowerCase().split(" ")[0]);
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
          {side} · Formula cross-check
        </div>
        <div className="text-[10px] text-slate-400 font-mono">median {fmtPower(median)}</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {rows.map(([name, val]) => {
          const delta = val - median;
          const highlight = isPrimary(name);
          return (
            <div
              key={name}
              data-testid={`comparison-${side.toLowerCase()}-${name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              className={
                "rounded-md border px-3 py-2 " +
                (highlight
                  ? "border-sky-400 bg-sky-50"
                  : "border-slate-200 bg-slate-50/60")
              }
            >
              <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
                {name}
              </div>
              <div className="font-serif text-lg font-semibold text-slate-900 mt-0.5">
                {fmtPower(val)}
              </div>
              <div className="text-[10px] font-mono text-slate-500">
                Δ {delta >= 0 ? "+" : ""}{delta.toFixed(2)} D
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function ComparisonCard({ result }) {
  return (
    <Card className="p-5 sm:p-6 border-slate-200" data-testid="comparison-card">
      <div className="flex items-center gap-2 mb-4">
        <Rows3 className="w-5 h-5 text-sky-700" />
        <h2 className="font-serif text-2xl font-semibold tracking-tight">Formula Comparison</h2>
        <span className="ml-2 text-xs text-slate-500">
          Cross-check IOL power across Barrett II, Kane, SRK/T, Haigis, Hoffer Q, Holladay 1
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <EyeComparison side="OD" data={result.od} primary={result.od?.formula_selection?.formula} />
        <EyeComparison side="OS" data={result.os} primary={result.os?.formula_selection?.formula} />
      </div>
    </Card>
  );
}
